import Vue from 'vue';
import Vuex from 'vuex';
// import API from './Api';
import ls from './localstorage';

Vue.use(Vuex);

let getDefaultState = () => {
    return {
        user: {fullname: "", username: "", email: "", club: "", avatar: "", id: "", user_type: ""},
        fansData: {},
        staticImage: "https://fela.matchday.ng//storage/uploads/avatar/avatar.jpg/",
        rawURI: "https://fela.matchday.ng/api/",
        homeURI: "https://fela.matchday.ng",
        projectName: "MatchDayNg",
        callbackUrl: "https://test.matchdaydeals.com/auth/callback",
        localhost: "http://localhost:8080",
        contributions: {},
        selectedLiveFeed: {},
        selectedImageFeed: {},
        selectedReview: {},
        notifications: {},
        isFromReferral: false,
    }
};

export default new Vuex.Store({
    state: getDefaultState(),
    mutations: {
        resetState (state) {
            Object.assign(state, getDefaultState());
        },
        setFansData(state, payload)  {
            state.fansData = payload;
        },
        logout(){
            ls.clearStorage('ticket')
            ls.clearStorage('fansData')
        },
        setContributions(state, payload) {
            state.contributions = payload;
        },
        selectedFeed(state, payload) {
            state.selectedLiveFeed = payload
        },
        selectedImageFeed(state, payload) {
            state.selectedImageFeed = payload
        },
        selectedReview(state, payload) {
            state.selectedReview = payload
        },
        setNotifications(state, payload) {
            state.notifications = payload
        },
    },
    actions: {
        async setFansData({commit}) {
            let datas = ls.getStorage('fansData');

            commit("setFansData", datas);
            return datas;
        },
        async getFansData({state}) {
            let data = state.fansData;
            return data;
        },
    },
    getters: {
        getNotifications: state => {
            return state.notifications
        },
    },
});
